import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MyBookingPage from './MyBookingPage';
import GetMyAppointmentsActions from '../../../redux/GetMyAppointmentsRedux';

// Phase 6 - Navigation integration implemented
interface MyBookingPageWrapperProps {
  t: (key: string) => string;
  getMyAppointments: () => void;
  getMyAppointmentsFetching: boolean;
  getMyAppointmentsSuccess: boolean;
  getMyAppointmentsError: boolean;
  appointments: any[];
}

const MyBookingPageWrapper: React.FC<MyBookingPageWrapperProps> = (props) => {
  // Phase 6 - Navigation integration implemented
  const navigate = useNavigate();

  const navigation = {
    goBack: () => navigate(-1)
  };

  return (
    <MyBookingPage
      {...props}
      // Phase 6 - Navigation integration implemented
      navigation={navigation}
    />
  );
};

// Phase 2 & 3 - Redux implemented
const mapStateToProps = (state: any) => {
  return {
    getMyAppointmentsFetching: state.getMyAppointments.fetching,
    getMyAppointmentsSuccess: state.getMyAppointments.success,
    getMyAppointmentsError: state.getMyAppointments.error,
    appointments: state.getMyAppointments.appointments,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMyAppointments: () => {
      dispatch(GetMyAppointmentsActions.getMyAppointmentsRequest());
    }
  };
};

// Phase 2 & 3 - Translations and Redux ready
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MyBookingPageWrapper));